import React, { Component } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Select from "react-select";

export default class Tabsharing extends Component {
  render() {
    const {
      removeUser,
      handleRegisteredUserChange,
      handleNotRegisteredUserChange,
      addUser,
      data,
      getAvailableUsers,
      formatSelectUsers,
    } = this.props;

    return (
      <>
        <div className="panel-body">
          <fieldset>
            <div className="d-flex gap-2 mb-2">
              <CopyToClipboard text={data?.sharingLink}>
                <button
                  type="linkclipboard"
                  className="btn btn-sm btn-green"
                >
                  Copy sharing-link to clipboard
                </button>
              </CopyToClipboard>

              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={addUser}
              >
                Add User/Email to share
              </button>
            </div>

            {data?.users?.map((user, index) => {
              const availableUsers = getAvailableUsers(index);
              return (
                <div className="row" key={index}>
                  <div className="col-12 col-md-5">
                    <div className="form-group">
                      <label>
                        <b>Email for non-registered user :</b>
                      </label>
                      <input
                        disabled={!!user.registerId}
                        type="email"
                        className="form-control"
                        name="nonRegistredUser"
                        value={user.nonRegisterEmail || ""}
                        onChange={(e) =>
                          handleNotRegisteredUserChange("nonRegisterEmail", e.target.value, index)
                        }
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-5">
                    <div className="form-group">
                      <label>
                        <b>Select Registered User :</b>
                      </label>
                      <Select
                        isDisabled={!!user.nonRegisterEmail}
                        options={availableUsers} 
                        placeholder="Select user"
                        value={availableUsers.find(u => u._id === user.registerId) || null}
                        formatOptionLabel={formatSelectUsers}
                        isOptionDisabled={(option) => option.invitationSent}
                        onChange={(e) =>
                          handleRegisteredUserChange("userid", e, index)
                        }
                      />
                    </div>
                  </div>

                  {index > 0 && (
                    <div className="col-12 col-md-2 d-flex align-items-center">
                      <div className="form-group">
                        <button
                          className="btn btn-danger btn-icon btn-circle btn-sm"
                          onClick={() => removeUser(index)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                        <button
                          className="btn btn-green btn-icon btn-circle btn-sm"
                          disabled
                        >
                          <i className="fas fa-check"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </fieldset>
        </div>
      </>
    );
  }
}
